import { FrameworkService } from "@opendash/core";
import { getAPI } from "../API";
type AdminFunctionInterface = {
  functionName: string;
  allowedRoles: string[];
  name: string;
  description: string;
};

async function registerAdminFunctions(
  $framework: FrameworkService,
  parentId: string
) {
  const API = getAPI();
  const [fetchPromise, cancel] = API.fetch(`/api/admin/functions`);
  const response: Response = await fetchPromise;

  if (response.status !== 200) {
    throw new Error("Network response was not ok");
  }
  const functions = (await response.json()).result as AdminFunctionInterface[];

  functions.forEach((func) => {
    const command = {
      id: func.functionName,
      parent: parentId,
      title: func.name,
      description: func.description,
      icon: "⚙️",
      handler: () => {
        API.fetch(`/api/admin/functions/${func.functionName}`, {
          method: "POST",
          body: JSON.stringify({}),
        });
      },
    };
    $framework.commands.registerCommand(command);
  });
}
export default registerAdminFunctions;
